module.exports = __webpack_public_path__ + "static/ursanex-think-like-a-doctor-40ab2b58f36828400e890f57b8c6ffce.pdf";